<div class="notifications__preview" [ngClass]="{hasLoader: loading}" (click)="displayListMobile.emit(false)">
  <wc-notification-center
    *ngIf="notificationV2; else oldNotifications"
    [config]="notificationCenterConfig"
    [isopen]="isShow"
    [showHeader]="showHeader"
    [defaultCategory]="defaultCategory"
    [activableNotifications]="activableNotifications"
    [channelId]="channelId"
    (read)="onNotificationClickHandler($event.detail)"
    (counterChange)="setCounter($event.detail)"
    (filterChanged)="onFilterChanged($event.detail)"
  ></wc-notification-center>
  <ng-template #oldNotifications>
    <div *ngFor="let notification of notifications">
      <vc-notification-item [notification]="notification"></vc-notification-item>
    </div>
  </ng-template>
</div>
